<div class="menus d-sm-flex animate align-items-stretch" (click)="showModal('800x800')" [ngClass]="{'touch': showHelpTouch}">
    <div class="menu-img img" [ngStyle]="{'background-image': 'url(' + image + ')'}"></div>
    <div class="text d-flex align-items-center">
        <div style="min-height: 100px;">
            <div class="d-flex">
                <div class="one-half">
                    <h3>{{ item.title}}</h3>
                </div>
                <div class="one-forth" *ngIf="param_code && param_code.verPrecios">
                    <span class="price" *ngIf="param_code.verPrecios && !param_code.descuento">{{ item.price | currency:'$'}}</span>

                    <span class="price" *ngIf="param_code.verPrecios && param_code.descuento > 0">{{ item.price - item.price * (param_code.descuento / 100) | currency:'$'}}</span>
                    <span class="badge badge-info" style="font-size: 0.8em; text-decoration: line-through;" *ngIf="param_code.verPrecios && param_code.descuento > 0">{{ item.price | currency:'$'}}</span>
                </div>
            </div>
            <p>{{ item.description }}</p>
            <span class="badge badge-dark">{{ item.category?.categoria | titlecase }}</span>
        </div>
    </div>
</div>

<!-- The Modal Show Image -->
<div id="{{idModal}}" class="modal">
    <span class="close" (click)="hideModal(idModal)">&times;</span>
    <div class="wathermark" (click)="hideModal(idModal)">
        <img class="modal-content" [src]="bigImage" id="img01">
    </div>
    <div id="caption">
        <h4>{{ item.title}}</h4>
        <p>
            {{ item.description | titlecase }}
        </p>
    </div>
</div>